import React from 'react'
import PropTypes from 'prop-types'

export const ICON_STYLES = {
  OUTLINE: 'outline',
  FILL: 'fill',
  TEAL_CIRCLE: 'teal-circle',
  BANNER: 'banner',
}

export const ICON_TYPES = {
  AIRPLAY: 'airplay',
  ALERT: 'alert',
  ALERT_OUTLINE: 'alert-outline',
  ALL: 'all',
  ARROW_DOWN: 'arrow-down',
  ARROW_DOWN_OUTLINE: 'arrow-down-outline',
  ARROW_UP: 'arrow-up',
  ARROW_UP_OUTLINE: 'arrow-up-outline',
  ARTICLE: 'article',
  ARTICLES: 'articles',
  BELL: 'bell',
  BELL_OFF: 'bell-off',
  BODY: 'body',
  BOOKMARK: 'bookmark',
  BROWSE: 'browse',
  CAMERA: 'camera',
  CC: 'cc',
  CHECK: 'check',
  CHECKBOX_CHECKED: 'checkbox-checked',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_RIGHT: 'chevron-right',
  CHEVRON_UP: 'chevron-up',
  CIRCULAR_ADD: 'circular-add',
  CIRCULAR_BELL_OFF: 'circular-bell-off',
  CIRCULAR_CHECK: 'circular-check',
  CIRCULAR_CHEVRON_LEFT: 'circular-chevron-left',
  CIRCULAR_CHEVRON_RIGHT: 'circular-chevron-right',
  CIRCULAR_COMMENTS: 'circular-comments',
  CIRCULAR_DETAILS: 'circular-details',
  CIRCULAR_ERROR: 'circular-error',
  CIRCULAR_EXPAND: 'circular-expand',
  CIRCULAR_FOLLOW_BELL: 'circular-follow_bell',
  CIRCULAR_INFO: 'circular-info',
  CIRCULAR_MINIMIZE: 'circular-minimize',
  CIRCULAR_PLAY: 'circular-play',
  CIRCULAR_PREVIEW: 'circular-preview',
  CIRCULAR_REMOVE: 'circular-remove',
  CIRCULAR_SERIES: 'circular-series',
  CIRCULAR_SHARE: 'circular-share',
  SHERPA: 'sherpa',
  CLOCK: 'clock',
  CLOCK_FILL: 'clock-fill',
  CLOSE: 'close',
  CLOSE_2: 'close-2',
  COLLAPSE: 'collapse',
  COMMENT: 'comment',
  COMMENT_OUTLINE: 'comment-outline',
  CONSCIOUSNESS: 'consciousness',
  COPY: 'copy',
  COVERUPS: 'coverups',
  DELETE: 'delete',
  DOCS_AND_FILMS: 'docs-and-films',
  DOTS_HORIZONTAL: 'dots-horizontal',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  ELLIPSIS: 'ellipsis',
  EMBED: 'embed',
  EMAIL: 'email',
  EPISODES: 'episodes',
  EVENTS: 'events',
  EXPAND: 'expand',
  EYE: 'eye',
  EYE_OFF: 'eye-off',
  FILTER_VERTICAL: 'filter-vertical',
  FLAG: 'flag',
  FRIENDS: 'friends',
  FRIENDS_2: 'friends-2',
  GEAR_OUTLINE: 'gear-outline',
  GIFT_OUTLINE: 'gift-outline',
  GLOBE: 'globe',
  GROWTH: 'growth',
  GUIDE: 'guide',
  HEADPHONES: 'headphones',
  HEALING: 'healing',
  HEALTH: 'health',
  HEART: 'heart',
  HEART_FILL: 'heart-fill',
  HEART_OFF: 'heart-off',
  HEART_OUTLINE: 'heart-outline',
  HIDE: 'hide',
  HIDE_2: 'hide-2',
  HOME: 'home',
  HOURGLASS: 'hourglass',
  INFO: 'info',
  LIBRARY: 'library',
  LIGHTHOUSE: 'lighthouse',
  LINK: 'link',
  LOCK: 'lock',
  LOGIN: 'login',
  LOGOUT: 'logout',
  MEDICINE: 'medicine',
  MEDICINE_2: 'medicine-2',
  MEDITATION: 'meditation',
  MENU: 'menu',
  METAPHYSICS: 'metaphysics',
  METAPHYSICS_2: 'metaphysics-2',
  MIC: 'mic',
  MIND: 'mind',
  MINUS: 'minus',
  NEW_VIDEOS: 'new-videos',
  ORIGINS: 'origins',
  PADLOCK: 'padlock',
  PAGINATION_FIRST: 'pagination-first',
  PAGINATION_LAST: 'pagination-last',
  PAGINATION_LEFT: 'pagination-left',
  PAGINATION_NEXT: 'pagination-next',
  PAUSE: 'pause',
  PDF: 'pdf',
  PDF_2: 'pdf-2',
  PENCIL: 'pencil',
  PHONE: 'phone',
  PLAY: 'play',
  PLAY_CIRCLE: 'play-circle',
  PLAYLIST: 'playlist',
  PLUS: 'plus',
  PREVIEW: 'preview',
  PRINTER: 'printer',
  RECOMMEND: 'recommend',
  RENAME: 'rename',
  REPLAY: 'replay',
  SCHEDULE: 'schedule',
  SEARCH: 'search',
  SECRETS: 'secrets',
  SETTINGS: 'settings',
  SERIES: 'series',
  SHARE: 'share',
  SHARE_ANDROID: 'share-android',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  PINTEREST: 'pinterest',
  REDDIT: 'reddit',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  SPIRIT: 'spirit',
  STAR: 'star',
  STAR_FILL: 'star-fill',
  SUPERNATURAL: 'supernatural',
  SWITCH_LANGUAGE: 'switch-language',
  SWITCH_LANGUAGE_OUTLINE: 'switch-language-outline',
  THIRD_EYE: 'third-eye',
  TRASH: 'trash',
  TV: 'tv',
  UNEXPLAINED: 'unexplained',
  VOLUME: 'volume',
  VOLUME_FULL: 'volume-full',
  VOLUME_LOW: 'volume-low',
  VOLUME_NULL: 'volume-null',
  YOGA: 'yoga',
  YOGA_2: 'yoga-2',
  USER: 'user',
  USERS: 'users',
  WEBSITE: 'link',
  X_CLOSE: 'x-close',
  // === Figma SVG Icons (prefixed by directory) ===
  APPSTORE_APPLE: 'appstore-apple',
  APPSTORE_GOOGLE: 'appstore-google',
  APPSTORE_HUAWEI: 'appstore-huawei',
  PLAYER_ADD_TO_PLAYLIST_FILLED: 'player-add-to-playlist-filled',
  PLAYER_ADD_TO_PLAYLIST_OUTLINE: 'player-add-to-playlist-outline',
  PLAYER_AIRPLAY_OUTLINE: 'player-airplay-outline',
  PLAYER_BELL_FILLED: 'player-bell-filled',
  PLAYER_BELL_OUTLINE: 'player-bell-outline',
  PLAYER_CHROME_CAST_OUTLINE: 'player-chrome-cast-outline',
  PLAYER_CLOCK_FILLED: 'player-clock-filled',
  PLAYER_CLOCK_OUTLINE: 'player-clock-outline',
  PLAYER_CLOSED_CAPTIONING_FILLED: 'player-closed-captioning-filled',
  PLAYER_EYE_FILLED: 'player-eye-filled',
  PLAYER_EYE_HIDDEN_FILLED: 'player-eye-hidden-filled',
  PLAYER_EYE_HIDDEN_OUTLINE: 'player-eye-hidden-outline',
  PLAYER_EYE_OUTLINE: 'player-eye-outline',
  PLAYER_FAST_BACKWARD_FILLED: 'player-fast-backward-filled',
  PLAYER_FAST_BACKWARD_OUTLINE: 'player-fast-backward-outline',
  PLAYER_FAST_FORWARD_FILLED: 'player-fast-forward-filled',
  PLAYER_FAST_FORWARD_OUTLINE: 'player-fast-forward-outline',
  PLAYER_FFWD10_FILLED: 'player-ffwd10-filled',
  PLAYER_FULLSCREEN_OUTLINE: 'player-fullscreen-outline',
  PLAYER_HEADPHONES_OUTLINE: 'player-headphones-outline',
  PLAYER_HOURGLASS_03_OUTLINE: 'player-hourglass-03-outline',
  PLAYER_LINK_03_OUTLINE: 'player-link-03-outline',
  PLAYER_MIC_OFF_OUTLINE: 'player-mic-off-outline',
  PLAYER_MIC_ON_OUTLINE: 'player-mic-on-outline',
  PLAYER_PAUSE_FILLED: 'player-pause-filled',
  PLAYER_PAUSE_OUTLINE: 'player-pause-outline',
  PLAYER_PIP_OUTLINE: 'player-pip-outline',
  PLAYER_PLAY_FILLED: 'player-play-filled',
  PLAYER_PLAY_OUTLINE: 'player-play-outline',
  PLAYER_PLAY_PLAYLIST_FILLED: 'player-play-playlist-filled',
  PLAYER_PLAY_PLAYLIST_OUTLINE: 'player-play-playlist-outline',
  PLAYER_PLAYLIST_FILLED: 'player-playlist-filled',
  PLAYER_PLAYLIST_OUTLINE: 'player-playlist-outline',
  PLAYER_PREVIEW_PLAY_FILLED: 'player-preview-play-filled',
  PLAYER_PREVIEW_PLAY_OUTLINE: 'player-preview-play-outline',
  PLAYER_REPLAY_OUTLINE: 'player-replay-outline',
  PLAYER_REWIND30_FILLED: 'player-rewind30-filled',
  PLAYER_SETTINGS_FILLED: 'player-settings-filled',
  PLAYER_SHARE_VIDEO_FILLED: 'player-share-video-filled',
  PLAYER_SHARE_VIDEO_OUTLINE: 'player-share-video-outline',
  PLAYER_SKIP_BACK_FILLED: 'player-skip-back-filled',
  PLAYER_SKIP_BACK_OUTLINE: 'player-skip-back-outline',
  PLAYER_SKIP_FORWARD_FILLED: 'player-skip-forward-filled',
  PLAYER_SKIP_FORWARD_OUTLINE: 'player-skip-forward-outline',
  PLAYER_SLIDE_BACK_FILLED: 'player-slide-back-filled',
  PLAYER_SLIDE_BACK_OUTLINE: 'player-slide-back-outline',
  PLAYER_SLIDE_NEXT_FILLED: 'player-slide-next-filled',
  PLAYER_SLIDE_NEXT_OUTLINE: 'player-slide-next-outline',
  PLAYER_STOP_FILLED: 'player-stop-filled',
  PLAYER_STOP_OUTLINE: 'player-stop-outline',
  PLAYER_VOLUME_MAX_FILLED: 'player-volume-max-filled',
  PLAYER_VOLUME_MAX_OUTLINE: 'player-volume-max-outline',
  PLAYER_VOLUME_MIN_FILLED: 'player-volume-min-filled',
  PLAYER_VOLUME_MIN_OUTLINE: 'player-volume-min-outline',
  PLAYER_VOLUME_MINUS_FILLED: 'player-volume-minus-filled',
  PLAYER_VOLUME_MINUS_OUTLINE: 'player-volume-minus-outline',
  PLAYER_VOLUME_PLUS_FILLED: 'player-volume-plus-filled',
  PLAYER_VOLUME_PLUS_OUTLINE: 'player-volume-plus-outline',
  PLAYER_VOLUME_X_FILLED: 'player-volume-x-filled',
  PLAYER_VOLUME_X_OUTLINE: 'player-volume-x-outline',
  ARROW_ARROW_DOWN_16: 'arrow-arrow-down-16',
  ARROW_ARROW_DOWN_24: 'arrow-arrow-down-24',
  ARROW_ARROW_DOWN_LEFT_16: 'arrow-arrow-down-left-16',
  ARROW_ARROW_DOWN_LEFT_24: 'arrow-arrow-down-left-24',
  ARROW_ARROW_DOWN_RIGHT_16: 'arrow-arrow-down-right-16',
  ARROW_ARROW_DOWN_RIGHT_24: 'arrow-arrow-down-right-24',
  ARROW_ARROW_LEFT_16: 'arrow-arrow-left-16',
  ARROW_ARROW_LEFT_24: 'arrow-arrow-left-24',
  ARROW_ARROW_RIGHT_16: 'arrow-arrow-right-16',
  ARROW_ARROW_RIGHT_24: 'arrow-arrow-right-24',
  ARROW_ARROW_UP_16: 'arrow-arrow-up-16',
  ARROW_ARROW_UP_24: 'arrow-arrow-up-24',
  ARROW_ARROW_UP_LEFT_16: 'arrow-arrow-up-left-16',
  ARROW_ARROW_UP_LEFT_24: 'arrow-arrow-up-left-24',
  ARROW_ARROW_UP_RIGHT_16: 'arrow-arrow-up-right-16',
  ARROW_ARROW_UP_RIGHT_24: 'arrow-arrow-up-right-24',
  ARROW_CHEVRON_DOWN_16: 'arrow-chevron-down-16',
  ARROW_CHEVRON_DOWN_24: 'arrow-chevron-down-24',
  ARROW_CHEVRON_LEFT_16: 'arrow-chevron-left-16',
  ARROW_CHEVRON_LEFT_24: 'arrow-chevron-left-24',
  ARROW_CHEVRON_RIGHT_16: 'arrow-chevron-right-16',
  ARROW_CHEVRON_RIGHT_24: 'arrow-chevron-right-24',
  ARROW_CHEVRON_UP_16: 'arrow-chevron-up-16',
  ARROW_CHEVRON_UP_24: 'arrow-chevron-up-24',
  ARROW_CORNER_DOWN_LEFT_16: 'arrow-corner-down-left-16',
  ARROW_CORNER_DOWN_LEFT_24: 'arrow-corner-down-left-24',
  ARROW_CORNER_DOWN_RIGHT_16: 'arrow-corner-down-right-16',
  ARROW_CORNER_DOWN_RIGHT_24: 'arrow-corner-down-right-24',
  ARROW_CORNER_LEFT_DOWN_16: 'arrow-corner-left-down-16',
  ARROW_CORNER_LEFT_DOWN_24: 'arrow-corner-left-down-24',
  ARROW_CORNER_LEFT_UP_16: 'arrow-corner-left-up-16',
  ARROW_CORNER_LEFT_UP_24: 'arrow-corner-left-up-24',
  ARROW_CORNER_RIGHT_DOWN_16: 'arrow-corner-right-down-16',
  ARROW_CORNER_RIGHT_DOWN_24: 'arrow-corner-right-down-24',
  ARROW_CORNER_RIGHT_UP_16: 'arrow-corner-right-up-16',
  ARROW_CORNER_RIGHT_UP_24: 'arrow-corner-right-up-24',
  ARROW_CORNER_UP_LEFT_16: 'arrow-corner-up-left-16',
  ARROW_CORNER_UP_LEFT_24: 'arrow-corner-up-left-24',
  ARROW_CORNER_UP_RIGHT_16: 'arrow-corner-up-right-16',
  ARROW_CORNER_UP_RIGHT_24: 'arrow-corner-up-right-24',
  ARROW_TRIANGLE_DOWN_16: 'arrow-triangle-down-16',
  ARROW_TRIANGLE_DOWN_24: 'arrow-triangle-down-24',
  ARROW_TRIANGLE_LEFT_16: 'arrow-triangle-left-16',
  ARROW_TRIANGLE_LEFT_24: 'arrow-triangle-left-24',
  ARROW_TRIANGLE_RIGHT_16: 'arrow-triangle-right-16',
  ARROW_TRIANGLE_RIGHT_24: 'arrow-triangle-right-24',
  ARROW_TRIANGLE_UP_16: 'arrow-triangle-up-16',
  ARROW_TRIANGLE_UP_24: 'arrow-triangle-up-24',
  GENERAL_A_PLUS_16: 'general-a-plus-16',
  GENERAL_A_PLUS_24: 'general-a-plus-24',
  GENERAL_BELL_16: 'general-bell-16',
  GENERAL_BELL_24: 'general-bell-24',
  GENERAL_BELL_OFF_16: 'general-bell-off-16',
  GENERAL_BELL_OFF_24: 'general-bell-off-24',
  GENERAL_BOOKMARK_16: 'general-bookmark-16',
  GENERAL_BOOKMARK_24: 'general-bookmark-24',
  GENERAL_BUILDING_16: 'general-building-16',
  GENERAL_BUILDING_24: 'general-building-24',
  GENERAL_CALENDAR_16: 'general-calendar-16',
  GENERAL_CALENDAR_24: 'general-calendar-24',
  GENERAL_CAMERA_16: 'general-camera-16',
  GENERAL_CAMERA_24: 'general-camera-24',
  GENERAL_CARDS_24: 'general-cards-24',
  GENERAL_CHECK_16: 'general-check-16',
  GENERAL_CHECK_24: 'general-check-24',
  GENERAL_CHECK_SQUARE_BROKEN_16: 'general-check-square-broken-16',
  GENERAL_CHECK_SQUARE_BROKEN_24: 'general-check-square-broken-24',
  GENERAL_CLOCK_16: 'general-clock-16',
  GENERAL_CLOCK_24: 'general-clock-24',
  GENERAL_COPY_16: 'general-copy-16',
  GENERAL_COPY_24: 'general-copy-24',
  GENERAL_DOCUMENT_16: 'general-document-16',
  GENERAL_DOCUMENT_24: 'general-document-24',
  GENERAL_DOT_16: 'general-dot-16',
  GENERAL_DOT_24: 'general-dot-24',
  GENERAL_DOTS_GRID_16: 'general-dots-grid-16',
  GENERAL_DOTS_GRID_24: 'general-dots-grid-24',
  GENERAL_DOTS_HORIZONTAL_16: 'general-dots-horizontal-16',
  GENERAL_DOTS_HORIZONTAL_24: 'general-dots-horizontal-24',
  GENERAL_DOTS_VERTICAL_16: 'general-dots-vertical-16',
  GENERAL_DOTS_VERTICAL_24: 'general-dots-vertical-24',
  GENERAL_DOWNLOAD_16: 'general-download-16',
  GENERAL_DOWNLOAD_24: 'general-download-24',
  GENERAL_EDIT_16: 'general-edit-16',
  GENERAL_EDIT_24: 'general-edit-24',
  GENERAL_EYE_16: 'general-eye-16',
  GENERAL_EYE_24: 'general-eye-24',
  GENERAL_EYE_OFF_16: 'general-eye-off-16',
  GENERAL_EYE_OFF_24: 'general-eye-off-24',
  GENERAL_FILE_PLUS_16: 'general-file-plus-16',
  GENERAL_FILE_PLUS_24: 'general-file-plus-24',
  GENERAL_FILTER_FUNNEL_16: 'general-filter-funnel-16',
  GENERAL_FILTER_FUNNEL_24: 'general-filter-funnel-24',
  GENERAL_FLAG_16: 'general-flag-16',
  GENERAL_FLAG_24: 'general-flag-24',
  GENERAL_GIFT_16: 'general-gift-16',
  GENERAL_GIFT_24: 'general-gift-24',
  GENERAL_GLOBE_16: 'general-globe-16',
  GENERAL_GLOBE_24: 'general-globe-24',
  GENERAL_GRID_16: 'general-grid-16',
  GENERAL_GRID_24: 'general-grid-24',
  GENERAL_HEART_16: 'general-heart-16',
  GENERAL_HEART_24: 'general-heart-24',
  GENERAL_HOME_16: 'general-home-16',
  GENERAL_HOME_24: 'general-home-24',
  GENERAL_ICON_BASIC_16: 'general-icon-basic-16',
  GENERAL_ICON_BASIC_24: 'general-icon-basic-24',
  GENERAL_INFO_CIRCLE_16: 'general-info-circle-16',
  GENERAL_INFO_CIRCLE_24: 'general-info-circle-24',
  GENERAL_LAYOUT_LEFT_16: 'general-layout-left-16',
  GENERAL_LAYOUT_LEFT_24: 'general-layout-left-24',
  GENERAL_LINK_16: 'general-link-16',
  GENERAL_LINK_24: 'general-link-24',
  GENERAL_LINK_BROKEN_16: 'general-link-broken-16',
  GENERAL_LINK_BROKEN_24: 'general-link-broken-24',
  GENERAL_LOCATION_16: 'general-location-16',
  GENERAL_LOCATION_24: 'general-location-24',
  GENERAL_LOCK_16: 'general-lock-16',
  GENERAL_LOCK_24: 'general-lock-24',
  GENERAL_LOG_IN_16: 'general-log-in-16',
  GENERAL_LOG_IN_24: 'general-log-in-24',
  GENERAL_LOG_OUT_16: 'general-log-out-16',
  GENERAL_LOG_OUT_24: 'general-log-out-24',
  GENERAL_MAXIMIZE_16: 'general-maximize-16',
  GENERAL_MAXIMIZE_24: 'general-maximize-24',
  GENERAL_MENU_16: 'general-menu-16',
  GENERAL_MENU_24: 'general-menu-24',
  GENERAL_MESSAGE_PLUS_SQUARE_16: 'general-message-plus-square-16',
  GENERAL_MESSAGE_PLUS_SQUARE_24: 'general-message-plus-square-24',
  GENERAL_MESSAGE_TEXT_SQUARE_16: 'general-message-text-square-16',
  GENERAL_MESSAGE_TEXT_SQUARE_24: 'general-message-text-square-24',
  GENERAL_MICROPHONE_16: 'general-microphone-16',
  GENERAL_MICROPHONE_24: 'general-microphone-24',
  GENERAL_MICROPHONE_OFF_16: 'general-microphone-off-16',
  GENERAL_MICROPHONE_OFF_24: 'general-microphone-off-24',
  GENERAL_MINIMIZE_16: 'general-minimize-16',
  GENERAL_MINIMIZE_24: 'general-minimize-24',
  GENERAL_MINUS_16: 'general-minus-16',
  GENERAL_MINUS_24: 'general-minus-24',
  GENERAL_MINUS_SQUARE_16: 'general-minus-square-16',
  GENERAL_MINUS_SQUARE_24: 'general-minus-square-24',
  GENERAL_NEW_CHAT_16: 'general-new-chat-16',
  GENERAL_NEW_CHAT_24: 'general-new-chat-24',
  GENERAL_OPEN_16: 'general-open-16',
  GENERAL_OPEN_24: 'general-open-24',
  GENERAL_PINNED_16: 'general-pinned-16',
  GENERAL_PINNED_24: 'general-pinned-24',
  GENERAL_PLUS_16: 'general-plus-16',
  GENERAL_PLUS_24: 'general-plus-24',
  GENERAL_PLUS_SQUARE_16: 'general-plus-square-16',
  GENERAL_PLUS_SQUARE_24: 'general-plus-square-24',
  GENERAL_PRINTER_16: 'general-printer-16',
  GENERAL_PRINTER_24: 'general-printer-24',
  GENERAL_REFRESH_16: 'general-refresh-16',
  GENERAL_REFRESH_24: 'general-refresh-24',
  GENERAL_SAGE_16: 'general-sage-16',
  GENERAL_SAGE_24: 'general-sage-24',
  GENERAL_SEARCH_16: 'general-search-16',
  GENERAL_SEARCH_24: 'general-search-24',
  GENERAL_SEND_16: 'general-send-16',
  GENERAL_SEND_24: 'general-send-24',
  GENERAL_SETTINGS_16: 'general-settings-16',
  GENERAL_SETTINGS_24: 'general-settings-24',
  GENERAL_SHARE_ANDROID_16: 'general-share-android-16',
  GENERAL_SHARE_ANDROID_24: 'general-share-android-24',
  GENERAL_SHARE_IOS_16: 'general-share-ios-16',
  GENERAL_SHARE_IOS_24: 'general-share-ios-24',
  GENERAL_SHOPPING_CART_16: 'general-shopping-cart-16',
  GENERAL_SHOPPING_CART_24: 'general-shopping-cart-24',
  GENERAL_SLASH_DIVIDER_16: 'general-slash-divider-16',
  GENERAL_SLASH_DIVIDER_24: 'general-slash-divider-24',
  GENERAL_STAR_16: 'general-star-16',
  GENERAL_STAR_24: 'general-star-24',
  GENERAL_STAR_AI_16: 'general-star-ai-16',
  GENERAL_STAR_AI_24: 'general-star-ai-24',
  GENERAL_STAR_AI_PLUS_16: 'general-star-ai-plus-16',
  GENERAL_STAR_AI_PLUS_24: 'general-star-ai-plus-24',
  GENERAL_STACKED_CARDS_24: 'general-stacked-cards-24',
  GENERAL_THUMBS_DOWN_16: 'general-thumbs-down-16',
  GENERAL_THUMBS_DOWN_24: 'general-thumbs-down-24',
  GENERAL_THUMBS_DOWN_FILLED_16: 'general-thumbs-down-filled-16',
  GENERAL_THUMBS_DOWN_FILLED_24: 'general-thumbs-down-filled-24',
  GENERAL_THUMBS_UP_16: 'general-thumbs-up-16',
  GENERAL_THUMBS_UP_24: 'general-thumbs-up-24',
  GENERAL_THUMBS_UP_FILLED_16: 'general-thumbs-up-filled-16',
  GENERAL_THUMBS_UP_FILLED_24: 'general-thumbs-up-filled-24',
  GENERAL_TRASH_16: 'general-trash-16',
  GENERAL_TRASH_24: 'general-trash-24',
  GENERAL_UNPINNED_16: 'general-unpinned-16',
  GENERAL_UNPINNED_24: 'general-unpinned-24',
  GENERAL_UPLOAD_16: 'general-upload-16',
  GENERAL_UPLOAD_24: 'general-upload-24',
  GENERAL_USER_16: 'general-user-16',
  GENERAL_USER_24: 'general-user-24',
  GENERAL_USER_ADD_16: 'general-user-add-16',
  GENERAL_USER_ADD_24: 'general-user-add-24',
  GENERAL_USER_CIRCLE_16: 'general-user-circle-16',
  GENERAL_USER_CIRCLE_24: 'general-user-circle-24',
  GENERAL_USERS_16: 'general-users-16',
  GENERAL_USERS_24: 'general-users-24',
  GENERAL_VOICE_16: 'general-voice-16',
  GENERAL_VOICE_24: 'general-voice-24',
  GENERAL_X_CIRCLE_16: 'general-x-circle-16',
  GENERAL_X_CIRCLE_24: 'general-x-circle-24',
  GENERAL_X_CLOSE_16: 'general-x-close-16',
  GENERAL_X_CLOSE_24: 'general-x-close-24',
  SOCIAL_DISCORD: 'social-discord',
  SOCIAL_EMAIL: 'social-email',
  SOCIAL_FACEBOOK: 'social-facebook',
  SOCIAL_GOOGLE: 'social-google',
  SOCIAL_INSTAGRAM: 'social-instagram',
  SOCIAL_LINKEDIN: 'social-linkedin',
  SOCIAL_MAIL_RU: 'social-mail-ru',
  SOCIAL_ODNOKLASSNIKI: 'social-odnoklassniki',
  SOCIAL_PHONE: 'social-phone',
  SOCIAL_REDDIT: 'social-reddit',
  SOCIAL_TELEGRAM: 'social-telegram',
  SOCIAL_TIKTOK: 'social-tiktok',
  SOCIAL_TWITCH: 'social-twitch',
  SOCIAL_TWITTER: 'social-twitter',
  SOCIAL_VK: 'social-vk',
  SOCIAL_WHATSAPP: 'social-whatsapp',
  SOCIAL_X: 'social-x',
  SOCIAL_YANDEX_ENG: 'social-yandex-eng',
  SOCIAL_YANDEX: 'social-yandex',
  SOCIAL_YOUTUBE: 'social-youtube',
  SORT_FILTER_OFF: 'sort-filter-off',
  SORT_FILTER: 'sort-filter',
  SORT_ICON_GRAPH: 'sort-icon-graph',
  SORT_SEARCH_FILE: 'sort-search-file',
  SORT_SEARCH_TEXT: 'sort-search-text',
  SORT_SEARCH: 'sort-search',
  SORT_SORT_ALPH_ASC: 'sort-sort-alph-asc',
  SORT_SORT_ALPH_DESC: 'sort-sort-alph-desc',
  SORT_SORT_ASC: 'sort-sort-asc',
  SORT_SORT_DESC: 'sort-sort-desc',
  SORT_SORT_NUM_ASC: 'sort-sort-num-asc',
  SORT_SORT_NUM_DESC: 'sort-sort-num-desc',
  SORT_SORT_TILES_ASC: 'sort-sort-tiles-asc',
  SORT_SORT_TILES_DESC: 'sort-sort-tiles-desc',
  TOPIC_ALL: 'topic-all',
  TOPIC_ALT_HEALING: 'topic-alt-healing',
  TOPIC_COURSES: 'topic-courses',
  TOPIC_CRYSTAL_BALL: 'topic-crystal-ball',
  TOPIC_CRYSTALS: 'topic-crystals',
  TOPIC_EVENTS_PLUS: 'topic-events-plus',
  TOPIC_EYE_OF_HORUS: 'topic-eye-of-horus',
  TOPIC_HAMSA: 'topic-hamsa',
  TOPIC_INSPIRING_DOCS: 'topic-inspiring-docs',
  TOPIC_LIGHTHOUSE: 'topic-lighthouse',
  TOPIC_MARKET: 'topic-market',
  TOPIC_MEDITATIN_2: 'topic-meditatin-2',
  TOPIC_MEDITATION: 'topic-meditation',
  TOPIC_METAPHYSICS: 'topic-metaphysics',
  TOPIC_MIND: 'topic-mind',
  TOPIC_PARANORMAL_UNEXPLAINED: 'topic-paranormal-unexplained',
  TOPIC_RECIPES: 'topic-recipes',
  TOPIC_SECRETS_COVERUPS: 'topic-secrets-coverups',
  TOPIC_SPIRITUAL_GROWTH: 'topic-spiritual-growth',
  TOPIC_STONES: 'topic-stones',
  TOPIC_UFO: 'topic-ufo',
  TOPIC_YOGA_2: 'topic-yoga-2',
  PAYMENT_AFFIRM: 'payment-affirm',
  PAYMENT_ALIPAY: 'payment-alipay',
  PAYMENT_AMAZON: 'payment-amazon',
  PAYMENT_AMEX: 'payment-amex',
  PAYMENT_AMEX2: 'payment-amex2',
  PAYMENT_APPLEPAY: 'payment-applepay',
  PAYMENT_BANCONTACT: 'payment-bancontact',
  PAYMENT_BITCOIN: 'payment-bitcoin',
  PAYMENT_BITCOINCASH: 'payment-bitcoincash',
  PAYMENT_BITPAY: 'payment-bitpay',
  PAYMENT_CARTEBANCAIREY46: 'payment-cartebancairey46',
  PAYMENT_CITADELE: 'payment-citadele',
  PAYMENT_CREDITCARD: 'payment-creditcard',
  PAYMENT_DINERSCLUB: 'payment-dinersclub',
  PAYMENT_DISCOVER: 'payment-discover',
  PAYMENT_ELO: 'payment-elo',
  PAYMENT_ETHERIUM: 'payment-etherium',
  PAYMENT_FACEBOOKPAY: 'payment-facebookpay',
  PAYMENT_FORBRUGSFORENINGEN: 'payment-forbrugsforeningen',
  PAYMENT_GIROPAY: 'payment-giropay',
  PAYMENT_GOOGLEPAY: 'payment-googlepay',
  PAYMENT_IDEAL: 'payment-ideal',
  PAYMENT_INTERAC: 'payment-interac',
  PAYMENT_JCB: 'payment-jcb',
  PAYMENT_KLARNA: 'payment-klarna',
  PAYMENT_LIGHTCOIN: 'payment-lightcoin',
  PAYMENT_MAESTRO: 'payment-maestro',
  PAYMENT_MASTERCARD: 'payment-mastercard',
  PAYMENT_MIR: 'payment-mir',
  PAYMENT_PAYONEER: 'payment-payoneer',
  PAYMENT_PAYPAL: 'payment-paypal',
  PAYMENT_PAYSAFE: 'payment-paysafe',
  PAYMENT_POLI: 'payment-poli',
  PAYMENT_QIWI: 'payment-qiwi',
  PAYMENT_ROKU: 'payment-roku',
  PAYMENT_SEPA: 'payment-sepa',
  PAYMENT_SHOP_PAY: 'payment-shop-pay',
  PAYMENT_SKRILL: 'payment-skrill',
  PAYMENT_SOFORT: 'payment-sofort',
  PAYMENT_STRIPE: 'payment-stripe',
  PAYMENT_UNIONPAY: 'payment-unionpay',
  PAYMENT_VENMO: 'payment-venmo',
  PAYMENT_VERIFONE: 'payment-verifone',
  PAYMENT_VISA_LOGO: 'payment-visa-logo',
  PAYMENT_WEBMONEY: 'payment-webmoney',
  PAYMENT_WECHAT: 'payment-wechat',
  PAYMENT_YANDEX: 'payment-yandex',
  PROCESSOR_AMAZON: 'processor-amazon',
  PROCESSOR_APPLE: 'processor-apple',
  PROCESSOR_NAME4: 'processor-name4',
  PROCESSOR_ROKU: 'processor-roku',
  PROCESSOR_ZUORA: 'processor-zuora',
}

function getClass (props) {
  const { type, style, className } = props
  const cls = ['icon-v2']
  if (type) cls.push(`icon-v2--${type}`)
  if (style) cls.push(`icon-v2--${style}`)
  if (className) cls.push(className)
  return cls.join(' ')
}

function IconV2 (props) {
  const { onClick, iconStyle = {} } = props
  return (
    <span
      className={getClass(props)}
      role="presentation"
      onClick={onClick}
      style={iconStyle}
    />
  )
}

IconV2.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOf([
    ICON_STYLES.OUTLINE,
    ICON_STYLES.FILL,
    ICON_STYLES.TEAL_CIRCLE,
    ICON_STYLES.BANNER,
  ]),
  onClick: PropTypes.func,
}

export default React.memo(IconV2)
